import React from "react";

const Batery = () => {
  return (
    <svg
      width="18"
      height="9"
      viewBox="0 0 18 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.28743 8.26465H12.6766C13.7665 8.26465 14.6228 8.1465 15.2395 7.53802C15.8503 6.92954 15.9641 6.09658 15.9641 5.02141V3.24324C15.9641 2.16216 15.8503 1.3292 15.2395 0.726627C14.6168 0.118151 13.7665 0 12.6766 0H3.26946C2.1976 0 1.34132 0.118151 0.730539 0.726627C0.113772 1.3351 0 2.16807 0 3.22552V5.02141C0 6.09658 0.113772 6.93545 0.724551 7.53802C1.34731 8.1465 2.1976 8.26465 3.28743 8.26465ZM3.11976 7.10677C2.50299 7.10677 1.92216 7.01816 1.58683 6.69324C1.2515 6.36242 1.17365 5.8012 1.17365 5.18682V3.08964C1.17365 2.46935 1.2515 1.90223 1.58084 1.57141C1.91617 1.24058 2.50299 1.15788 3.13174 1.15788H12.8443C13.4671 1.15788 14.0479 1.24058 14.3772 1.57141C14.7126 1.90223 14.7904 2.46344 14.7904 3.07783V5.18682C14.7904 5.8012 14.7126 6.36242 14.3772 6.69324C14.0479 7.02406 13.4671 7.10677 12.8443 7.10677H3.11976ZM2.88623 6.36242H10.0539C10.4251 6.36242 10.6467 6.30925 10.8024 6.15566C10.9521 6.00206 11.012 5.78348 11.012 5.42312V2.84153C11.012 2.47526 10.9521 2.25668 10.8024 2.10899C10.6467 1.9554 10.4251 1.90223 10.0539 1.90223H2.8982C2.51497 1.90223 2.29341 1.9554 2.13772 2.10308C1.98802 2.25668 1.92814 2.48117 1.92814 2.85334V5.42312C1.92814 5.78939 1.98802 6.00206 2.13772 6.15566C2.29341 6.30925 2.51497 6.36242 2.88623 6.36242ZM16.8383 5.73031C17.3353 5.70078 18 5.07458 18 4.12937C18 3.19007 17.3353 2.55796 16.8383 2.52843V5.73031Z"
        fill="#1C1C1E"
      />
    </svg>
  );
};

export default Batery;
